'use client';

import { type Product } from '@/domain/products/types';
import { TabPanel, TabView } from 'primereact/tabview';
import { Suspense } from 'react';

import {
  BrochureTab,
  BusinessModelTab,
  DocumentsTab,
  Overview,
  PlantsDataTable,
  ProcedureDataTable,
  RoadmapTab,
  StreamVideoTab,
} from './components';
import { MaturitySectionWrapper } from './components/Overview/components';
import TabHeaderTemplate from './TabHeaderTemplate';

interface ProductDetailProps {
  detailedProduct: Product;
  isInternal: boolean;
}

const ProductDetail = ({ detailedProduct, isInternal }: ProductDetailProps) => (
  <TabView className="tabView" scrollable aria-owns="tab-content">
    <TabPanel headerClassName="tabPanel" header="Overview">
      <Overview product={detailedProduct} isInternal={isInternal} />
    </TabPanel>
    {detailedProduct.documentation && (
      <TabPanel headerClassName="tabPanel" header="Brochure">
        <BrochureTab detailedProduct={detailedProduct} />
      </TabPanel>
    )}
    {detailedProduct.businessModels && isInternal && (
      <TabPanel headerClassName="tabPanel" header="Business Models" headerTemplate={TabHeaderTemplate}>
        <BusinessModelTab detailedProduct={detailedProduct} />
      </TabPanel>
    )}
    {isInternal && (
      <TabPanel headerClassName="tabPanel" header="Roadmap">
        <RoadmapTab product={detailedProduct} />
      </TabPanel>
    )}
    {isInternal && (
      <TabPanel headerClassName="tabPanel" header="Plants" headerTemplate={TabHeaderTemplate}>
        <Suspense fallback={<i className="pi pi-spin pi-spinner" style={{ fontSize: '3rem' }} />}>
          <PlantsDataTable productId={detailedProduct.idProduct} />
        </Suspense>
      </TabPanel>
    )}
    {detailedProduct.streamVideos?.length > 0 && (
      <TabPanel headerClassName="tabPanel" header="Videos">
        <StreamVideoTab streamVideos={detailedProduct.streamVideos} />
      </TabPanel>
    )}
    {detailedProduct.linkYammer && (
      <TabPanel headerClassName="tabPanel" header="News Feed">
        <iframe
          name="embed-feed"
          title="Yammer"
          src={detailedProduct.linkYammer}
          style={{ border: '0px', overflow: 'hidden', width: '100%', height: '100%', minHeight: '400px' }}
        />
      </TabPanel>
    )}
    {detailedProduct.procedures?.length > 0 && isInternal && (
      <TabPanel headerClassName="tabPanel" header="Procedures" headerTemplate={TabHeaderTemplate}>
        <ProcedureDataTable procedures={detailedProduct.procedures} />
      </TabPanel>
    )}
    {detailedProduct.documents && detailedProduct.documents.length > 0 && isInternal && (
      <TabPanel headerClassName="tabPanel" header="Documents" headerTemplate={TabHeaderTemplate}>
        <DocumentsTab documents={detailedProduct.documents} />
      </TabPanel>
    )}

    {detailedProduct.idMaturityModel && isInternal && (
      <TabPanel headerClassName="tabPanel" header="Maturity" headerTemplate={TabHeaderTemplate}>
        <Suspense fallback={<i className="pi pi-spin pi-spinner" style={{ fontSize: '3rem' }} />}>
          <MaturitySectionWrapper
            idProduct={detailedProduct.idProduct}
            idMaturityModel={detailedProduct.idMaturityModel}
          />
        </Suspense>
      </TabPanel>
    )}
  </TabView>
);

export default ProductDetail;
